var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9a9da2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 17.5c4.1421 0 7.5-3.3579 7.5-7.5 0-4.14214-3.3579-7.5-7.5-7.5-4.14214 0-7.5 3.35786-7.5 7.5 0 4.1421 3.35786 7.5 7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 10h15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.99984 17.5c1.84096 0 3.33336-3.3579 3.33336-7.5 0-4.14214-1.4924-7.5-3.33336-7.5-1.84095 0-3.33334 3.35786-3.33334 7.5 0 4.1421 1.49239 7.5 3.33334 7.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebGrey);
export default __webpack_public_path__ + "static/media/web_grey.5d20a7df8c92ee924bd21524fe39bcdb.svg";
export { ForwardRef as ReactComponent };